import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import Article from '../components/Article'

class ArtigoPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            article: null
        }
    }

    componentDidMount() {
        const id = this.props.match.params.id;
        const url = `https://api.talkative.media/v1/blog/${id}`
        fetch(url)
            .then(response => response.json())
            .then(article => this.setState({article}))
    }
    render() {
        const { article } = this.state
        return article ? <Article article={article} /> : 'loading'
    }
}

export default withRouter(ArtigoPage)


// WEBPACK FOOTER //
// ./src/pages/artigo.js